import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@platform/state/hooks';
import { toastShown } from '@platform/state/slices/uiSlice';
import { errorText } from './errorText';

/** Показ помилки збереження системної сторінки спливним повідомленням: текст сервера (валідація, права) або «Не вдалося зберегти зміни». */
export function useFailToast(): (error: unknown) => void {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  return useCallback((error: unknown) => {
    dispatch(toastShown({ kind: 'error', text: errorText(error, t('sysPages.saveFailed')) }));
  }, [dispatch, t]);
}
